import { fromBinaryUUID, toBinaryUUID, createBinaryUUID } from "binary-uuid";
const Buffer = require('buffer/').Buffer 

const isBinary = (value) => value?.type === "Buffer";
const isBuffer = (value) => value instanceof Buffer;

export const convertToUUID = (value) => {
  if (!value) return ;
  if (isBinary(value)) return fromBinaryUUID(Buffer.from(value));
  if (isBuffer(value)) return fromBinaryUUID(value);
  return value;
};
export const convertToBinary = (value: string) => toBinaryUUID(value);
export const createBinUUID = (value: string) => createBinUUID(value);